/* unplugin-vue-components disabled */import { render } from "./DownloadBottom.vue?vue&type=template&id=89e371ae"
import script from "./DownloadBottom.vue?vue&type=script&lang=js"
export * from "./DownloadBottom.vue?vue&type=script&lang=js"

import "./DownloadBottom.vue?vue&type=style&index=0&id=89e371ae&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__